const behavioursAll = [...document.querySelectorAll('[data-behaviour]')]

export const initialize = (selectorString, component) => {
  const instances = behavioursAll.filter(
    el => el.dataset.behaviour === selectorString
  )

  instances.forEach(el => new component(el))
}

export const initializeWithClass = (selectorString, component) => {
  const instances = [...document.querySelectorAll(selectorString)]

  instances.forEach(el => new component(el))
}
